import { VPagination } from 'vuetify/lib/components/VPagination';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"pagination"}},[_c(VPagination,{attrs:{"length":_vm.lastPage,"total-visible":_vm.totalVisible},model:{value:(_vm.pageDirty),callback:function ($$v) {_vm.pageDirty=$$v},expression:"pageDirty"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }